import React from "react";
import styles from "./googlePlaces.module.css";
import ReactGoogleAutocomplete from "react-google-autocomplete";

const GooglePlaces = ({ id, label, key,required=false,handleChange, ...googlePlacesArgs }) => {
  console.log("asdfafd", googlePlacesArgs?.inputStyleOverride);
  return (
    <div
      className={`${styles.formGroup} ${googlePlacesArgs?.formGroupClassOverride}`}
      style={googlePlacesArgs.formGroupStyleOverride}
      key={key}
    >
      {label && (
        <label style={googlePlacesArgs.labelStyleOverride} htmlFor={id}>
            {label&&<label style={googlePlacesArgs.labelStyleOverride} htmlFor={id}>{label}
               {required&&<span className="required">*</span>}</label>}
            </label>
      )}

      <ReactGoogleAutocomplete
        {...googlePlacesArgs}
        required
        className={styles.input}
        libraries={["places"]}
        apiKey={process.env.REACT_APP_GOOGLE_PLACES_API_KEY}
        onPlaceSelected={(place) => googlePlacesArgs?.onPlaceSelected(place?.formatted_address)}
      />
    </div>
  );
};

export default React.memo(GooglePlaces);
